export function save_Token(token){
	return {type: 'SAVE_TOKEN', token: token};
}

export function configAction(config){
	return {type: 'CONFIG_ACTION', config: config};
}

